<template>
  <footer class="page-footer mt-auto font-small pt-4">
    <div class="container-fluid text-center text-md-left">
      <div class="row">
        <div class="col-md-4 mb-3">
          <h5>Contact Us</h5>
          <div>
            <a href="mailto:soncraft79@gmail.com" class=""
              >soncraft79@gmail.com</a
            >
          </div>
          <div>
            <a href="mailto:spaceback179@gmail.com" class=""
              >spaceback179@gmail.com</a
            >
          </div>
        </div>

        <div class="col-md-4 mb-3">
          <form
            target="_blank"
            action="https://www.paypal.com/donate"
            method="post"
          >
            <input
              type="hidden"
              name="hosted_button_id"
              value="4ZSHDKQ3H8LQJ"
            />
            <input
              type="image"
              target="_blank"
              src="https://www.paypalobjects.com/en_US/i/btn/btn_donateCC_LG.gif"
              name="submit"
              title="PayPal - The safer, easier way to pay online!"
              alt="Donate with PayPal button"
            />
            <img
              alt=""
              src="https://www.paypal.com/en_PH/i/scr/pixel.gif"
              width="1"
              height="1"
            />
          </form>
        </div>

        <div class="col-md-4 mb-3">
          <h5>Visit Us</h5>
          <div>
            <a href="https://soncraft.itch.io/" target="_blank">
              <img src="../assets/itch.png" alt="" height="18px" />
              soncraft.itch.io</a
            >
          </div>
          <div>
            <a href="https://github.com/zan79" target="_blank">
              <img src="../assets/github.png" alt="" height="20px" />
              github.com/zan79</a
            >
          </div>
        </div>
      </div>
    </div>
    <div class="footer-copyright text-center py-1 text-light">
      © 2022 Soncraft
    </div>
  </footer>
</template>

<script>
export default {};
</script>

<style>
footer {
  background-color: #212121;
}
footer img {
  height: 20px;
}
footer .footer-copyright {
  border-top: 1px solid #313131;
}
footer h5 {
  color: #ff6600;
}
footer a {
  color: #808080;
  text-decoration: none;
}
footer a:hover {
  color: #fff;
}
</style>